
import { computed, defineComponent } from 'vue';
import { useStore } from 'vuex';
import { Container } from '@/components/bosons';
import { ImageInfo } from '@/components/atoms';
import { PokemonDetails } from '@/components/molecules';

export default defineComponent({
  name: 'Component',
  components: {
    ImageInfo,
    Container,
    PokemonDetails,
  },
  setup() {
    const store = useStore();

    return {
      detail: computed(() => store.state.pokemon),
      loading: computed(() => store.state.loading),
    };
  },
});
